module.exports = __webpack_public_path__ + "img/test_local_server.bd976672.png";